import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path
      key='0'
      fill='#000000'
      d='M15.8,11.3h-1.9V9.8c0-1-0.7-1.6-1.6-1.6H2.8c-0.9,0-1.6,0.7-1.6,1.6v7.1c0,0.9,0.7,1.6,1.6,1.6l0,0c0,1.3,1,2.4,2.4,2.4
	s2.4-1,2.4-2.4h4.8c0,1.3,1,2.4,2.4,2.4s2.4-1,2.4-2.4h1c0.3,0,0.6-0.2,0.6-0.6v-3c0-0.3-0.1-0.7-0.3-0.9l-1.8-2.5
	C16.4,11.4,16.1,11.3,15.8,11.3z M5.2,19.7c-0.7,0-1.1-0.6-1.1-1.1s0.5-1.2,1.1-1.2s1.1,0.6,1.1,1.1C6.3,19,5.8,19.7,5.2,19.7z
	 M15.9,12.5l1.6,2h-3.6v-2H15.9z M14.6,19.7c-0.7,0-1.1-0.6-1.1-1.1s0.6-1.1,1.1-1.1c0.7,0,1.1,0.6,1.1,1.1S15.3,19.7,14.6,19.7z'
    />,
    <path
      key='1'
      fill='#000000'
      d='M22.3,8.8l-1.7-2.4c-0.2-0.2-0.4-0.3-0.7-0.3h-1.8V4.7c0-0.9-0.7-1.6-1.6-1.6H7.5c-0.9,0-1.5,0.7-1.5,1.5v1.7
	c0,0.7,0.6,1.2,1.2,1.2c0,0,5,0,5.1,0c1.8,0,2.1,1.2,2.1,2v0.5c0,0.4,0.3,0.6,0.6,0.6h1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.4,0.1
	c0.6,0.5,0.9,1.1,1.4,1.6c0.2-0.3,0.4-0.7,1.1-0.7c0.6,0,1.1,0.6,1.1,1.1s-0.5,1-1,1.1c0.2,0.3,0.3,0.4,0.5,0.6
	c0.2,0.2,0.5,0.3,0.8,0.1c0.6-0.4,1-1,1-1.8h1c0.3,0,0.6-0.2,0.6-0.6V9.7C22.6,9.4,22.5,9.1,22.3,8.8z M18.1,9.2V7.3H20l1.5,1.9
	H18.1z'
    />,
  ],
  'TransportGroupRounded'
);

const TransportGroupRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportGroupRoundedIcon);
